import { render, staticRenderFns } from "./CartDropdown.vue?vue&type=template&id=405a3980&scoped=true"
import script from "./CartDropdown.vue?vue&type=script&lang=js"
export * from "./CartDropdown.vue?vue&type=script&lang=js"
import style0 from "./CartDropdown.vue?vue&type=style&index=0&id=405a3980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405a3980",
  null
  
)

export default component.exports